/* Kinora — thème Shopify : panier latéral, variantes, galerie, menu */
(function () {
  'use strict';

  var K = window.KINORA || {};
  var R = K.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add.js', cartChange: '/cart/change.js' };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

  /* ---------- Message flottant ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('[data-toast]');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2200);
  }

  /* ---------- Panier latéral ---------- */
  function openCart(open) {
    var d = $('[data-drawer]');
    var s = $('[data-shade]');
    if (!d || !s) return;
    d.classList.toggle('open', open);
    s.classList.toggle('open', open);
    d.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('no-scroll', open);
    if (open) {
      var c = $('[data-act="close-cart"]', d);
      if (c) c.focus();
    }
  }

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (e) { e.textContent = n; });
  }

  function refreshDrawer() {
    return fetch(R.root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var doc = new DOMParser().parseFromString(j['cart-drawer'], 'text/html');
        var src = $('[data-drawer-inner]', doc);
        var dst = $('[data-drawer-inner]');
        if (src && dst) dst.innerHTML = src.innerHTML;
        var c = $('[data-count-value]', doc);
        if (c) setCount(c.textContent.trim());
      });
  }

  function addToCart(id, qty, btn) {
    if (btn) btn.disabled = true;
    return fetch(R.cartAdd, {
      method: 'POST',
      headers: JSON_HEADERS,
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: parseInt(qty, 10) || 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          toast(res.j.description || res.j.message || 'Impossible d’ajouter ce produit.');
          return null;
        }
        return refreshDrawer().then(function () { openCart(true); });
      })
      .catch(function () { toast('Une erreur est survenue, merci de réessayer.'); })
      .then(function () { if (btn) btn.disabled = false; });
  }

  function changeLine(line, qty) {
    return fetch(R.cartChange, {
      method: 'POST',
      headers: JSON_HEADERS,
      body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(qty, 10) })
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.status && j.description) toast(j.description);
        return refreshDrawer();
      })
      .catch(function () { toast('Une erreur est survenue, merci de réessayer.'); });
  }

  /* ---------- Événements globaux ---------- */
  document.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('[data-act]') : null;
    if (!el) return;
    var act = el.getAttribute('data-act');

    if (act === 'open-cart') {
      if (!$('[data-drawer]')) return;
      e.preventDefault();
      openCart(true);
    } else if (act === 'close-cart') {
      openCart(false);
    } else if (act === 'line-qty') {
      changeLine(el.getAttribute('data-line'), el.getAttribute('data-qty'));
    } else if (act === 'menu') {
      var m = $('#menu');
      if (!m) return;
      var o = !m.classList.contains('open');
      m.classList.toggle('open', o);
      el.setAttribute('aria-expanded', o ? 'true' : 'false');
    } else if (act === 'qty-step') {
      var f = el.closest('form');
      if (!f) return;
      var inp = $('[name="quantity"]', f);
      var out = $('[data-qty-display]', f);
      var v = Math.max(1, Math.min(20, (parseInt(inp.value, 10) || 1) + parseInt(el.getAttribute('data-step'), 10)));
      inp.value = v;
      if (out) out.textContent = v;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') openCart(false);
  });

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('[data-ajax-form]')) return;
    var idInput = $('[name="id"]', f);
    if (!idInput || !idInput.value) return;
    e.preventDefault();
    var q = $('[name="quantity"]', f);
    addToCart(idInput.value, q ? q.value : 1, e.submitter || $('[type="submit"]', f));
  });

  document.addEventListener('change', function (e) {
    var s = e.target;
    if (!s.matches || !s.matches('[data-sort]')) return;
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', s.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });

  /* ---------- Page produit : variantes + galerie ---------- */
  function initProduct(root) {
    var dataEl = $('[data-variants]', root);
    var form = $('[data-ajax-form]', root);
    if (!dataEl || !form) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var L = {
      add: root.getAttribute('data-label-add') || 'Ajouter au panier',
      soldout: root.getAttribute('data-label-soldout') || 'Épuisé',
      unavailable: root.getAttribute('data-label-unavailable') || 'Indisponible'
    };

    function showSlide(mediaId) {
      var slides = $$('[data-slide]', root);
      var found = slides.some(function (s) { return s.getAttribute('data-media-id') === String(mediaId); });
      if (!found) return;
      slides.forEach(function (s) { s.hidden = s.getAttribute('data-media-id') !== String(mediaId); });
      $$('[data-thumb]', root).forEach(function (t) {
        t.setAttribute('aria-pressed', t.getAttribute('data-media-id') === String(mediaId) ? 'true' : 'false');
      });
    }

    $$('[data-thumb]', root).forEach(function (t) {
      t.addEventListener('click', function () { showSlide(t.getAttribute('data-media-id')); });
    });

    function selectedValues() {
      return $$('[data-option-index]', root)
        .filter(function (i) { return i.checked; })
        .sort(function (a, b) { return a.getAttribute('data-option-index') - b.getAttribute('data-option-index'); })
        .map(function (i) { return i.value; });
    }

    function setButtons(disabled, label) {
      $$('[data-submit]', root).forEach(function (b) { b.disabled = disabled; b.textContent = label; });
    }

    function apply(v) {
      if (!v) { setButtons(true, L.unavailable); return; }
      $('[name="id"]', form).value = v.id;
      $$('[data-price]', root).forEach(function (e) { e.textContent = v.price; });
      $$('[data-compare]', root).forEach(function (e) { e.textContent = v.compare; e.hidden = !v.has_compare; });
      $$('[data-badge]', root).forEach(function (e) { e.textContent = '-' + v.pct + '%'; e.hidden = !v.has_compare; });
      setButtons(!v.available, v.available ? L.add : L.soldout);
      if (v.media) showSlide(v.media);
      try { history.replaceState(null, '', window.location.pathname + '?variant=' + v.id); } catch (err) { /* ignore */ }
    }

    $$('[data-option-index]', root).forEach(function (input) {
      input.addEventListener('change', function () {
        var sel = selectedValues();
        var match = variants.filter(function (v) {
          return v.options.every(function (o, i) { return o === sel[i]; });
        })[0];
        apply(match);
      });
    });
  }

  function initAll() {
    $$('[data-product-root]').forEach(initProduct);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
